<span *ngIf="this.createUser.loading">
    <p-progressSpinner [style]="{width: '30px', height: '30px'}" styleClass="custom-spinner">
    </p-progressSpinner>
</span>
<ng-container *ngIf="this.createUser.loading==false;">
    <div class="ui-g">
        <div class="ui-g-12">
            <div class="ui-g">
                <div class="ui-g-12" style="display: flex;
                flex-wrap: wrap;">
                    <div class="ui-g-12 ui-lg-4">
                        <h2 class="boldnlabel heading3" style="color:#004aad;">Patient details</h2>
                    </div>
                    <div class="ui-g-12 ui-lg-6">
                    </div>
                    <div class="ui-g-12 ui-lg-2" style="display: flex;
                        flex-direction: column;
                        justify-content: flex-end;" *ngIf="this.createUser.other_view_details.is_support_role">
                        <a [routerLink]="this.slug" role="button" (click)="showdialog()"
                            style="color:#004aad;align-self: flex-end;"><u>Contact
                                Patient</u></a>
                    </div>
                </div>
                <div class="ui-g-12 form-group basiccard">
                    <div class="ui-g-12 ui-lg-6">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory">Vendor:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">
                                {{this.createUser.viewDetails.egd_vendors.vendor_name}}
                            </p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">First Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.first_name}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="mname">Middle Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.middle_name || 'N/A'}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="lname">Last Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.last_name}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="email">Email:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.e_email || 'N/A'}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="address">Address:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.address || 'N/A'}}</p>
                        </div>

                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="country">Country:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.country.country_name}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="country">Request Status:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.status}}</p>
                        </div>

                    </div>
                    <div class="ui-g-12 ui-lg-6">

                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="policy_no">Policy No:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.policy_no}}</p>
                        </div>

                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="expiry_date">Expiry Date:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.expiry_date}}</p>
                        </div>

                        <div class="ui-g-12 ui-lg-4 WordWrap-break">
                            <label class="boldmedicalhistory" for="booking_id">Booking Id(CRN):</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.booking_id_no}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="gender">Gender:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.gender}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="dob">Date of Birth:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.date_of_birth}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="phno">Mobile Number:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.primary_contact_number}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="state">State:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.country_states.state_name}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ui-g"
        *ngIf="this.createUser.viewDetails.e_users !=null && this.createUser.other_view_details.is_support_role">
        <div class="ui-g-12">

            <div class="ui-g">
                <div class="ui-g-12" style="display: flex;
                flex-wrap: wrap;">

                    <div class="ui-g-12 ui-lg-4">
                        <h2 class="boldnlabel heading3" style="color:#004aad;">Request Created For Details</h2>
                    </div>
                    <div class="ui-g-12 ui-lg-6">
                    </div>

                </div>
                <div class="ui-g-12 form-group basiccard">
                    <div class="ui-g-12 ui-lg-6 ml-lg-3">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="state">Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.e_users.first_name + ' ' +
                                (this.createUser.viewDetails.e_users?.middle_name || "") + ' ' +
                                this.createUser.viewDetails.e_users.last_name}}
                            </p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="state">Phone number:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.e_users.primary_contact_number || 'N/A'}}
                            </p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="state">Email:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="nomargin">{{this.createUser.viewDetails.e_users.e_email || 'N/A'}}</p>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-lg-6"></div>
                </div>

            </div>

        </div>
    </div>

    <div class="ui-g" *ngIf="this.createUser.viewDetails.p_consultation !=null">
        <div class="ui-g-12">

            <div class="ui-g">
                <div class="ui-g-12" style="display: flex;
                flex-wrap: wrap;">
                    <div class="ui-g-12 ui-lg-4">
                        <h2 class="boldnlabel heading3" style="color:#004aad;">Consultation Details</h2>
                    </div>
                    <div class="ui-g-12 ui-lg-6">
                    </div>
                    <div class="ui-g-12 ui-lg-2"
                        *ngIf="this.createUser.viewDetails.status=='CONSULTATION NOT BOOKED' && this.createUser.other_view_details.is_support_role"
                        style="display: flex;
                        flex-direction: column;
                        justify-content: flex-end;">
                        <a [routerLink]="['../', this.slug, 'create-consultation']" role="button"
                            style="color:#004aad;align-self: flex-end;"><u>Create
                                Consultation</u></a>
                    </div>
                </div>
                <div class="ui-g-12 form-group basiccard">

                    <div class="ui-g-12 ui-lg-5 ml-lg-3">
                        <div class="ui-g-12 ui-lg-6">
                            <label class="boldmedicalhistory" for="status">Status:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <p class="nomargin">
                                {{this.createUser.viewDetails.p_consultation.consultation_status}}
                            </p>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <label class="boldmedicalhistory" for="con_start_time">Consultation Date:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <p class="nomargin">{{this.createUser.viewDetails.p_consultation.consultation_date == null ?
                                "N/A" :
                                this.createUser.viewDetails.p_consultation.consultation_date | date:'medium' }}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <label class="boldmedicalhistory" for="con_reason">Consultation Reason:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <p class="nomargin">{{this.createUser.viewDetails.p_consultation.condition_description}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <label class="boldmedicalhistory" for="con_type">Consultation Type:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <p class="nomargin">
                                {{this.createUser.viewDetails.consultation_name}}</p>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <label class="boldmedicalhistory" for="con_end_time">Consultation Request Number:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <p class="nomargin">
                                {{this.createUser.viewDetails.p_consultation.consultation_request_number}}</p>
                        </div>
                        
                    </div>
                    <div class="ui-g-12 ui-lg-6"></div>
                </div>
            </div>
        </div>
    </div>


    <div class="ui-g" *ngIf="this.createUser.other_view_details.isactivity">
        <div class="ui-g-12">
            <div class="ui-g">
                <div class="ui-g-12" style="display: flex;
                flex-wrap: wrap;">
                    <div class="ui-g-12 ui-lg-4">
                        <h2 class="boldnlabel heading3" style="display:inline-block">Request Activity</h2>
                    </div>
                </div>
            </div>

            <div class="ui-g">
                <div class="ui-g-12 form-group basiccard">

                    <div class="ui-g-12 ui-lg-8 ml-lg-3">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Time Stamp</label>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                            <p class="boldmedicalhistory nomargin">
                                Action
                            </p>
                        </div>
                        <div *ngFor="let activity of this.createUser.other_view_details.activities_list">
                            <div class="ui-g-12 ui-lg-4">
                                <p for="firstname">{{activity.timestamp | date:'medium'}}</p>
                            </div>
                            <div class="ui-g-12 ui-lg-6">
                                <p>{{activity.action}}</p>
                            </div>
                        </div>

                    </div>
                    <div class="ui-g-12 ui-lg-4 ml-lg-3"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="ui-g" *ngIf="this.createUser.other_view_details.isPatientContactActivity">
        <div class="ui-g-12">
            <div class="ui-g">
                <div class="ui-g-12" style="display: flex;
                flex-wrap: wrap;">
                    <div class="ui-g-12 ui-lg-4">
                        <h2 class="boldnlabel heading3" style="display:inline-block">Patient Contacted Activity</h2>
                    </div>
                </div>
            </div>

            <div class="ui-g">
                <div class="ui-g-12 form-group basiccard">

                    <div class="ui-g-12 ui-lg-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Reason</label>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <p class="boldmedicalhistory">
                                Comments
                            </p>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <p class="boldmedicalhistory">
                                Contacted By
                            </p>
                        </div>

                        <div *ngFor="let contacted of this.createUser.other_view_details.patient_contacted_list">
                            <div class="ui-g-12 ui-lg-4">
                                <p for="firstname">{{contacted.reason}}</p>
                            </div>
                            <div class="ui-g-12 ui-lg-4">
                                <p>{{contacted.comments}}</p>
                            </div>
                            <div class="ui-g-12 ui-lg-4">
                                <p>{{contacted.first_name + " " + contacted.last_name}}</p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>


</ng-container>

<p-dialog *ngIf="this.createUser.display" header="Patient Details" [(visible)]="this.createUser.display"
    [style]="{ width: '50vw' }">
    <div class="flex py-2">
        <div class="ui-g">
            <div class="ui-g-12">
                <div class="ui-g-12 ml-lg-4">
                    <div class="ui-g-12 ui-lg-6">
                        <span class="font-weight-bold">Name : </span>{{this.createUser.viewDetails.first_name + " " +
                        this.createUser.viewDetails.last_name}}
                    </div>
                    <div class="ui-g-12 ui-lg-6">
                        <span class="font-weight-bold">Mobile Number :
                        </span>{{this.createUser.viewDetails.primary_contact_number}}
                    </div>
                </div>
                <div class="ui-g-12 ml-lg-4">
                    <div class="ui-g-12 ui-lg-12">
                        <span class="font-weight-bold">Email Address : </span>{{this.createUser.viewDetails.e_email ||
                        "N/A"}}
                    </div>
                </div>
                <form accept-charset="UTF-8" (ngSubmit)="contactPatient()" #ContactPatientForm="ngForm">
                    <div class="form-group ui-g-12">
                        <div class="mt-3 ml-lg-5">
                            <span class="margin2"><b>Reason for contacting*: </b></span><input type="text" pInputText
                                class="form-control" id="fname" name="fname"
                                [(ngModel)]="this.createUser.contactUser.reason" #reason="ngModel"
                                aria-describedby="reason" placeholder="Reason*" required>
                        </div>
                        <div *ngIf="reason.invalid && (reason.dirty || reason.touched)" class="ui-g-12">
                            <div *ngIf="reason.errors.required" class="ui-g-12 alert alert-danger m-2" role="alert">
                                Reason is required.
                            </div>
                        </div>
                    </div>
                    <div class="form-group ui-g-12">
                        <div class="mt-3 ml-lg-5">
                            <label class="ui-g-12 font-weight-bolder" for="Comments"><b>Comments*</b></label>
                            <textarea id="Comments" class="WordWrap format-lines textarea-input height-100px"
                                placeholder="Type Here" name="Comments" pInputTextarea
                                [(ngModel)]="this.createUser.contactUser.comments" #comments="ngModel">
                                </textarea>
                        </div>
                        <div *ngIf="comments.invalid && (comments.dirty || comments.touched)" class="ui-g-12">
                            <div *ngIf="comments.errors.required" class="ui-g-12 alert alert-danger m-2" role="alert">
                                Comments are required.
                            </div>
                        </div>
                        <div class="ui-g-12 ml-lg-5">
                            <p [style.color]="this.createUser.contactUser.comments.length-999>0?'red':'green'">
                                {{(1001-this.createUser.contactUser.comments.length)
                                <0?0:1000-this.createUser.contactUser.comments.length}} of 1000 characters left</p>

                        </div>
                    </div>
                    <div class="ui-g-12 ui-md-12 text-center">
                        <button type="submit" [disabled]="isPosting() ||
                            !ContactPatientForm.valid"
                            class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons">
                            <span class="egd-theme-white-bg-btn-label ">
                                Submit
                            </span>
                        </button>
                    </div>
                    <div class="ui-md-12 text-center" *ngIf="this.createUser.create_api_result.PromiseResult.success">
                        <p class="heading4 alert-success1">
                            {{this.createUser.create_api_result.PromiseResult.data.message}}
                        </p>
                    </div>
                    <div
                        *ngIf="this.createUser.create_api_result.ServerError?.error!=null || this.createUser.create_api_result.ServerError?.statusCode==500 || this.createUser.create_api_result.ServerError?.statusCode==400">
                        <p class="alert-danger mt-2">{{this.createUser.create_api_result.ServerError?.message}}</p>
                    </div>
                </form>

            </div>
        </div>

    </div>
</p-dialog>